import { ModelTypes } from '../models/types'
import { JSX } from 'react'
import { StringACTN } from './actionModels/StringACTN'
import { BlockACTN } from './actionModels/BlockACTN/BlockACTN'
import { IntegerACTN } from './actionModels/IntegerACTN'
import { DoubleACTN } from './actionModels/DoubleACTN'
import { DurationACTN } from './actionModels/DurationACTN'
import { EnumACTN } from './actionModels/EnumACTN'
import { BoolACTN } from './actionModels/BoolACTN'
import { DateTimeACTN } from './actionModels/DateTimeACTN'
import { BlockArrayACTN } from './actionModels/BlockArrayACTN/BlockArrayACTN'
import { WrappedBlockACTN } from './actionModels/BlockACTN/WrappedBlockACTN'
import { BlockDictionaryACTN } from './actionModels/BlockDictionaryACTN/BlockDictionaryACTN'
import { BlockModels } from '../models/Block/types'
import { SyncSettings } from './actionModels/BlockModelsACTN/SyncSettings'

export const buildActionsUI = (
    path: string,
    name: string,
    schema: any = {},
    data: any = {},
    wrapper?: string,
    isParentDisabled?: boolean,
    levelDeep?: number,
    element_id?: string,
    inCard?: boolean,
    isRuleActive?: boolean,
    pathWithElementID?: string
) => {
    const type: string = (schema.type as string) || 'default'

    const uiElements: { [key: string]: JSX.Element } = {
        [ModelTypes.BLOCK]:
            schema.model === BlockModels.SYNC_SETTINGS ? (
                <SyncSettings
                    dataPath={path}
                    data={data}
                    dataSchema={schema}
                    name={name}
                    wrapper={wrapper}
                />
            ) : wrapper ? (
                <WrappedBlockACTN
                    key={name + path}
                    dataPath={path}
                    data={data?.[name]}
                    dataSchema={schema}
                    title={schema?.name}
                    name={name}
                    wrapper={wrapper || 'block'}
                    levelDeep={levelDeep}
                    element_id={element_id}
                />
            ) : (
                <BlockACTN
                    key={name + path}
                    dataPath={path}
                    name={name}
                    dataSchema={schema}
                    data={data?.[name]}
                    title={schema?.name}
                    wrapper={wrapper || ''}
                    element_id={element_id}
                />
            ),
        [ModelTypes.BLOCK_ARRAY]: (
            <BlockArrayACTN
                key={name + path}
                dataPath={path}
                schema={schema}
                data={data?.[name]}
                title={name}
                wrapper={wrapper || ''}
                levelDeep={levelDeep}
                element_id={element_id}
            />
        ),
        [ModelTypes.BLOCK_DICTIONARY]: (
            <BlockDictionaryACTN
                key={name + path}
                dataPath={path}
                name={name}
                schema={schema}
                data={data?.[name]}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.STRING]: (
            <StringACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.INTEGER]: (
            <IntegerACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.DOUBLE]: (
            <DoubleACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.NUMBER]: (
            <DoubleACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.DURATION]: (
            <DurationACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.ENUM]: (
            <EnumACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.BOOL]: (
            <BoolACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.FLAG]: (
            <BoolACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
                wrapper={wrapper || ''}
            />
        ),
        [ModelTypes.DATETIME]: (
            <DateTimeACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
            />
        ),
        [ModelTypes.TIME]: (
            <DateTimeACTN
                key={name + path}
                dataPath={path}
                name={name}
                dataSchema={schema}
                data={data}
            />
        ),
        default: <></>,
    }

    return uiElements[type]
}
